import { useAuth } from '../../lib/auth.js'
import styles from './AdminHeader.module.css'

interface AdminHeaderProps {
  title: string
  onToggleSidebar: () => void
}

export function AdminHeader({ title, onToggleSidebar }: AdminHeaderProps) {
  const { user } = useAuth()

  return (
    <header className={styles.root}>
      <button className={styles.toggleBtn} onClick={onToggleSidebar} aria-label="사이드바 토글">
        ☰
      </button>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.userInfo}>
        <span className={styles.userName}>{user?.name ?? user?.email}</span>
      </div>
    </header>
  )
}
